export const centersConstants = {
  CENTER_DATA_BY_ID: "CENTER_DATA_BY_ID",
  APPROVED_CENTERS_LIST: "APPROVED_CENTERS",
  PENDING_CENTERS_LIST: "PENDING_CENTERS",
  CENTERS_LIST: "CENTERS_LIST",
  GET_CENTER_LOGO: "GET_CENTER_LOGO",
  CENTER_SPOT_DATA_BY_ID: "CENTER_SPOT_DATA_BY_ID",
  SET_CENTER_STATUS_IN_LOGIN_REDUCER: "SET_CENTER_STATUS_IN_LOGIN_REDUCER",
  SET_ISMEMBER_STATUS_IN_LOGIN_REDUCER: "SET_ISMEMBER_STATUS_IN_LOGIN_REDUCER",
  SET_ISFREELANCER_STATUS_IN_LOGIN_REDUCER:
    "SET_ISFREELANCER_STATUS_IN_LOGIN_REDUCER",
  IS_CENTER_REPAYMENT_MODAL: "IS_CENTER_REPAYMENT_MODAL",
};

export const centerStatusConstants = {
  PENDING_CENTER: "PENDING_CENTER",
  PAYMENT_REJECTED: "PAYMENT_REJECTED",
  PAYMENT_PENDING: "PAYMENT_PENDING",
  DISABLED: "DISABLED",
  REJECTED: "REJECTED",
  APPROVED: "APPROVED",
  RESTRICTED: "RESTRICTED",
};

export const centerStatusClasses = {
  0: "text-green",
  1: "text-darkRed",
  2: "text-yellow",
};

export const centerInstructorsConstants = {
  GET_INSTRUCTOR_BY_EMAIL: "GET_INSTRUCTOR_BY_EMAIL",
  GET_CENTER_INSTRUCTORS: "GET_CENTER_INSTRUCTORS",
  GET_CENTER_INSTRUCTOR_DETAIL_BY_ID: "GET_CENTER_INSTRUCTOR_DETAIL_BY_ID",
  RESET_INSTRUCTOR_DETAILS: "RESET_INSTRUCTOR_DETAILS",
  OPEN_HEAD_INSTRUCTOR_MODAL: "OPEN_HEAD_INSTRUCTOR_MODAL",
};

export const centerInvitationStatusConstants = {
  0: "NOT_REQUESTED",
  1: "APPROVED",
  2: "REJECTED",
  3: "PENDING_CENTER",
  4: "removed",
  5: "REQUEST_REMOVED",
};

export const CenterStatusEnum = {
  Rejected: 0,
  Pending: 1,
  Approved: 2,
  PaymentRejected: 3,
  PaymentPending: 4,
  Disabled: 5,
  Restricted: 6,
};

export const CenterSpotStatusEnum = {
  PaymentPending: 0,
  Rejected: 1,
  Pending: 2,
  Approved: 3,
  PaymentRejected: 4,
};

export const centerInvitationStatuses = {
  NotInvited: 0,
  Approved: 1,
  Rejected: 2,
  Pending: 3,
};

export const centerAppliedForStatus = {
  Center: "Center",
  Nafes: "Nafes",
  Spot: "Spot",
};

export const centerTabsConstants = {
  CENTER_GENERAL: 0,
  CENTER_LOCATION: 1,
  CENTER_MEMBERSHIP: 2,
  CENTER_INSTRUCTORS: 3,
};
